import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {FeatureFilterConfiguration} from "../core/config/feature-filter-configuration";
import {GeoICONS} from "../core/components/icon/icon";
import {MapViewConfiguration} from "../core/config/view-configuration";

@JsonObject()
export class TopicLayerConfiguration {
    @JsonProperty()
    declare id: string;
    @JsonProperty()
    declare layerId?: number;
    @JsonProperty()
    declare layerIds?: number[];
    constructor() {
    }
}
export class TopicLayersConfiguration {
    @JsonProperty()
    declare open?: TopicLayerConfiguration[];
    @JsonProperty()
    declare visible: TopicLayerConfiguration[];
    @JsonProperty()
    declare hide: TopicLayerConfiguration[];
    @JsonProperty()
    declare ignore?: TopicLayerConfiguration[];
    constructor() {
    }
}
@JsonObject()
export class TopicBasemapConfiguration {
    @JsonProperty()
    declare default?: string;
    @JsonProperty()
    declare opacity?: number;
    constructor() {
    }
}
@JsonObject() // "LayerConfiguration"
export class TopicConfiguration {

    /**
     * Identifier
     */
    @JsonProperty()
    declare id: string;

    @JsonProperty()
    declare parentId?: string;
    /**
     * Short name ( used in site title)
     */
    @JsonProperty()
    declare name?: string;

    /**
     * Label for displaying
     */
    @JsonProperty()
    declare label: string;

    /**
     * Website Meta description
     */
    @JsonProperty()
    declare description: string;

    /**
     * Icon type
     */
    @JsonProperty()
    declare icon: GeoICONS;

    /**
     * Ids of layers to apply the filter
     */
    @JsonProperty()
    declare layers: TopicLayersConfiguration;

    /**
     * filter to use for this topic
     */
    @JsonProperty()
    declare filter: FeatureFilterConfiguration;

    /**
     * Base IDs contained within this topic
     * Used to find stations when addressed by url (station no is not unique)
     */
    @JsonProperty()
    declare baseIds: number[];

    /**
     * BasemapConfiguration
     */
    @JsonProperty()
    declare basemap?: TopicBasemapConfiguration;
    /**
     * View settings
     */
    @JsonProperty()
    declare mapView?: MapViewConfiguration;

    /**
     * Routes to access this topic
     * Add "/" to load the topic at startup
     */
    @JsonProperty()
    declare routes: string[];

    revision = "initial";

    constructor() {}
}
